import { useAuth0 } from '@auth0/auth0-react'
import { Button, ButtonProps } from '@dfh-corp-sites/ui'
import { useLocation } from '@gatsbyjs/reach-router'
import React from 'react'

import { usePageUrl } from '../../lib/pages'
import { Maybe } from '../../utils/types'

export interface LoginLinkProps {
  className?: string
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void
  redirectPath?: Maybe<string>
  variant?: ButtonProps['variant']
}

const LoginLink: React.FC<LoginLinkProps> = ({
  className,
  children,
  onClick,
  redirectPath,
  variant = 'text',
}) => {
  const { loginWithRedirect } = useAuth0()
  const location = useLocation()
  const { getPagePath, navigate } = usePageUrl()

  return (
    <Button
      className={className}
      onClick={(event) => {
        onClick?.(event)
        loginWithRedirect({
          // use relative path to avoid unloading application
          appState: {
            returnTo: redirectPath
              ? getPagePath(redirectPath)
              : location
                ? `${location.pathname}${location.search}${location.hash}`
                : '',
          },
        }).catch(() => navigate('/login'))
      }}
      variant={variant}
    >
      {children}
    </Button>
  )
}

export default LoginLink
